/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube generates thumbnail files at 16:9 for every video, including vertical Shorts. A 9:16 Short doesn't have a native 16:9 frame, so the CDN image ends up letterboxed with bars, or cropped to a horizontal slice of the original vertical frame — that's expected, not a bug in this tool.`)
};

const es_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube genera los archivos de miniatura en formato 16:9 para todos los videos, incluidos los Shorts verticales. Un Short en 9:16 no tiene un fotograma nativo en 16:9, así que la imagen del CDN termina con bandas negras (letterbox) o recortada a una franja horizontal del fotograma vertical original — esto es normal, no un error de esta herramienta.`)
};

const de_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube erzeugt Thumbnail-Dateien für jedes Video im Format 16:9 — auch für vertikale Shorts. Ein 9:16-Short hat kein natives 16:9-Bild, weshalb das CDN-Bild entweder mit schwarzen Balken versehen oder auf einen horizontalen Ausschnitt des ursprünglichen vertikalen Bilds zugeschnitten wird. Das ist normal und kein Fehler dieses Tools.`)
};

const nl_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube genereert thumbnailbestanden in 16:9 voor elke video, inclusief verticale Shorts. Een 9:16 Short heeft geen natuurlijk 16:9-frame, dus de afbeelding van de CDN krijgt zwarte balken (letterbox) of wordt bijgesneden tot een horizontale plak van het originele verticale frame — dat is verwacht gedrag, geen bug in deze tool.`)
};

const fr_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube génère les fichiers de miniature en 16:9 pour chaque vidéo, y compris les Shorts verticaux. Un Short en 9:16 n’a pas d’image native en 16:9, donc l’image du CDN se retrouve soit avec des bandes noires (letterboxing), soit recadrée en une tranche horizontale de l’image verticale d’origine — c’est un comportement attendu, pas un bug de cet outil.`)
};

const it_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube genera i file delle miniature in formato 16:9 per ogni video, inclusi gli Shorts verticali. Uno Short in 9:16 non ha un fotogramma 16:9 nativo, quindi l'immagine dalla CDN risulta con bande nere ai lati, oppure ritagliata in una fetta orizzontale del fotogramma verticale originale — è normale, non un bug di questo strumento.`)
};

const pt_br2_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O YouTube gera arquivos de thumbnail em 16:9 para todos os vídeos, incluindo Shorts verticais. Um Short em 9:16 não tem um frame nativo em 16:9, então a imagem do CDN acaba com faixas pretas (letterbox) ou cortada em uma fatia horizontal do frame vertical original — isso é esperado, não é um bug desta ferramenta.`)
};

const pt_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O YouTube gera ficheiros de miniatura em 16:9 para todos os vídeos, incluindo Shorts verticais. Um Short em 9:16 não tem um enquadramento nativo de 16:9, por isso a imagem do CDN acaba com faixas pretas (letterbox), ou cortada numa fatia horizontal do fotograma vertical original — isto é esperado, não é um erro desta ferramenta.`)
};

const ja_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeは、縦型のShortsを含むすべての動画に対して16:9のサムネイルファイルを生成します。9:16のShortにはネイティブの16:9フレームが存在しないため、CDNの画像は上下に黒帯が入ったレターボックス状態になるか、元の縦フレームを横方向に切り取った状態になります。これは想定された挙動であり、このツールの不具合ではありません。`)
};

const zh_yt_shorts_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 会为每个视频生成 16:9 比例的缩略图文件，包括竖屏的 Shorts。9:16 的 Short 没有原生的 16:9 画面，因此 CDN 图片最终会带有黑边，或被裁剪为原始竖屏画面的水平切片 — 这是正常现象，并非本工具的错误。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq3_a", locale)
	if (locale === "en") return en_yt_shorts_faq3_a(inputs)
	if (locale === "es") return es_yt_shorts_faq3_a(inputs)
	if (locale === "de") return de_yt_shorts_faq3_a(inputs)
	if (locale === "nl") return nl_yt_shorts_faq3_a(inputs)
	if (locale === "fr") return fr_yt_shorts_faq3_a(inputs)
	if (locale === "it") return it_yt_shorts_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq3_a(inputs)
	if (locale === "pt") return pt_yt_shorts_faq3_a(inputs)
	if (locale === "ja") return ja_yt_shorts_faq3_a(inputs)
	return zh_yt_shorts_faq3_a(inputs)
};